import config from "config/config";
import FooterEVL from "./footer-evl";
import FooterWLP from "./footer-wlp";

export default function Footer({ portal }) {
  return config.COMPANY_NAME === "everlake" ? (
    <FooterEVL portal={portal} />
  ) : (
    <FooterWLP portal={portal} />
  );
}
